import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subscription, timer } from 'rxjs';
import { CounterService } from 'src/app/_services/counter.service';
import { ImportService } from 'src/app/_services/import.service';
import { Imports } from 'src/app/_models/import';
import { SuccessEvent, UploadEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { NotifyService } from 'src/app/_services/notify.service';
import { Counter } from 'src/app/_models/counter';

@Component({
   selector: 'app-import',
   templateUrl: './import.component.html',
   styleUrls: ['./import.component.scss'],
})
export class ImportComponent implements OnInit, OnDestroy {
   public opened = false;
   isForProgress = false;
   selectedImport: Imports;
   baseUrl = environment.apiUrl;
   public uploadSaveUrl = '';
   UploadValue = 0;
   UploadType = '';
   AMSTimer: any;
   @Input()
   errorList: string[];
   @Input()
   IsError = false;
   private timerSubscription: Subscription;
   @Output()
   dialogClose: EventEmitter<boolean> = new EventEmitter<boolean>();
   private Importubscription: Subscription;

   fileRestrictions: FileRestrictions = {
      allowedExtensions: ['.xls', '.xlsx'],
      maxFileSize: 50 * 1024 * 1024,
   };
   constructor(private importService: ImportService, private counterService: CounterService, private notify: NotifyService) {}

   ngOnInit() {
      this.Importubscription = this.importService.ImportSelected.subscribe((importObj: Imports) => {
         this.selectedImport = importObj;

         const extraParam = this.selectedImport.urlParameter ? '/' + this.selectedImport.urlParameter : '';

         this.uploadSaveUrl = this.baseUrl + this.selectedImport.url + '/import' + extraParam;
         this.opened = true;
      });
      this.Importubscription = this.importService.ProgressSelected.subscribe((s: string) => {
         this.selectedImport = {
            url: 'nothing',
            module: s,
            title: 'Import Excel Items',
         };
         this.opened = true;
         this.isForProgress = true;
         this.showProgress();
      });
   }
   ngOnDestroy() {
      this.Importubscription.unsubscribe();
   }
   closeDialog() {
      this.opened = false;
      this.dialogClose.emit(null);
      this.IsError = false;
      this.errorList = [];
      this.UploadType = '';
   }

   successEventHandler(e: SuccessEvent) {
      if (e.response) {
         this.UploadValue = 100;
         this.timerSubscription.unsubscribe();
         this.UploadValue = 0;
         this.closeDialog();
         const message = 'Successfully uploaded';
         this.notify.success(message);
         this.IsError = false;
         this.errorList = [];
         this.UploadType = '';
      }
   }
   errorEventHandler(e: any) {
      this.timerSubscription.unsubscribe();
      this.IsError = true;
      if (e.response.error == null) {
         this.errorList.push(e.response);
      } else {
         if (typeof e.response.error === 'string' || e.response.error instanceof String) {
            this.errorList.push(e.response.error);
         } else {
            if (e.response.status === 0) {
               this.errorList.push('The file has changed, rather select the file again than retrying. Or the server is unreachable.');
            } else {
               this.errorList = e.response.error;
            }
         }
      }

      this.UploadValue = 0;
      this.UploadType = '';
   }
   uploadEventHandler(e: UploadEvent) {
      this.errorList = [];
      this.IsError = false;
      e.headers = e.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

      e.data = {
         description: 'Upload',
         File: e.files[0].rawFile,
      };
      if (this.timerSubscription) {
         this.timerSubscription.unsubscribe();
      }
      this.showProgress();
   }

   showProgress() {
      this.UploadType = 'Warming up...';
      this.UploadValue = 1;
      this.AMSTimer = timer(3000, 3000);
      this.timerSubscription = this.AMSTimer.subscribe((t) => {
         this.counterService.getCounter(this.selectedImport.module).subscribe((counter: Counter) => {
            this.UploadType = counter.importType;
            this.UploadValue = +counter.value;

            if (this.isForProgress && this.UploadValue === 100) {
               this.close();
            }
         });
      });
   }

   public close() {
      this.opened = false;
      this.IsError = false;
      this.UploadType = '';
      this.errorList = [];
      this.timerSubscription.unsubscribe();
   }
}
